import React, { useEffect, useState, useRef } from "react"
import { message, Tabs } from 'antd';
import MeetingRooms from './MeetingRooms'
import ExtraFacilities from './ExtraFacility/ExtraFacility'
import MeetingPayment from './MeetingPayment/MeetingPayment'
import MeetingRates from './MeetingRates/MeetingRates'
import './MeetingRooms/index.scss'

import RoomDetailEdit from './MeetingRooms/components/roomsComponents/RoomDetailEdit'
import RoomDetailView from './MeetingRooms/components/roomsComponents/RoomDetailView'
import RoomDetailAdd from './MeetingRooms/components/roomsComponents/RoomDetailAdd'

import RoomCapacity from './MeetingRooms/components/roomsComponents/RoomCapacity'

import RoomServiceEdit from './MeetingRooms/components/roomsComponents/RoomServiceEdit'
import RoomServiceView from './MeetingRooms/components/roomsComponents/RoomServiceView'
import RoomServiceAdd from './MeetingRooms/components/roomsComponents/RoomServiceAdd'

import RoomService from './MeetingRooms/components/roomsComponents/RoomService'

import { LocalPersistence } from "../../../factories";
import { getMeetingRooms, addMeetingRoom } from "../../../services/meetingrooms";
import Loading from "../../Loading";

const { TabPane } = Tabs;


const MeetingFacilities = () => {
    const [currentOneNav, setCurrentOneNav] = useState('orign')
    const [roomDetailEditFlag, setRoomDetailEditFlag] = useState(false)
    const [roomCapacityEditFlag, setRoomCapacityEditFlag] = useState(false)
    const [roomServiceEditFlag, setRoomServiceEditFlag] = useState(false)
    const [currentLine, setCurrentLine] = useState<any>()
    const [orignactiveKey, setOrignactiveKey] = useState('1')
    const [addActivityKey, setAddActivityKey] = useState('5')
    const [editViewActivityKey, setEditViewActivityKey] = useState('8')
    const [meetingroomTabsActivityKey, setMeetingroomTabsActivityKey] = useState('1')

    const [OneNavDisabled, setOneNavDisabled] = useState(false)
    const [tableOneNavDisabled, setTableOneNavDisabled] = useState(false)

    const [allAPIdata, setAllAPIdata] = useState<any>(null)
    const [meetingroomsId, setMeetingroomsId] = useState('')
    const [mRoomsLoading, setMRoomsLoading] = useState<boolean>(false)
    const [disabledStatus, setDisabledStatus] = useState(true)

    const detailAddRef = useRef<any>()
    const capacityAddRef = useRef<any>()
    const serviceAddRef = useRef<any>()
    // table add
    const addSave = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        Promise.all([detailAddRef.current.detailsForm.validateFields()])
        .then(async (value) => {
            setMRoomsLoading(true)
            let detailFormData = value[0]
            for (var a in detailFormData) detailFormData[a] = detailFormData[a] || ''
            let capacityArr: [] = []
            let serviceArr: [] = []

            let boduQuery = {
                supplier: session.supplier,
                propertyId: session.propertyId,
                property: {
                    meetingrooms: {
                        meetingroomsid: allAPIdata?.meetingrooms?.meetingroomsid || '',
                        meetingroom: [
                            {
                                ...detailFormData,
                                capacity: capacityArr,
                                service: serviceArr,
                            }
                        ]
                    }
                }
            }
            addMeetingRoom(boduQuery).then(res => {
                if (res.result.success) {
                    setCurrentOneNav('orign')
                    setOrignactiveKey('1')
                    window.cancelEdition()
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
                setMRoomsLoading(false)
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setMRoomsLoading(false)
            })
        }).catch(() => {
            message.error({
                content: 'Check all the fields please.',
            });
        })
    }

    const origntabsChange = (key: any) => {
        setOrignactiveKey(key)
    }

    const tabsAddChange = (key: any) => {
        setAddActivityKey(key)
    }

    const tabsEditViewChange = (key: any) => {
        setEditViewActivityKey(key)
    }

    const getAllData = async () => {
        setMRoomsLoading(true)
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        getMeetingRooms(session.supplier, session.propertyId).then(res => {
            if (res.result.success) {
                let rest = res.property || {} || ''
                setAllAPIdata(rest)
                setMeetingroomsId(rest?.meetingrooms?.meetingroomsid || '')
            } else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
            setMRoomsLoading(false)
        }, err => {
            message.error({
                content: err?.message || err?.error[0]?.message
            });
            setMRoomsLoading(false)
        })
    }
    useEffect(() => {
        getAllData()
    }, [])

    useEffect(() => {
        setAddActivityKey('5')
        setEditViewActivityKey('8')
    }, [currentOneNav])
    const validateFieldsError = (isDisabled?: boolean) => {
        if (isDisabled) {
            setDisabledStatus(isDisabled)
            return;
        }
        Promise.all([
            detailAddRef.current.detailsForm.validateFields()])
            .then(() => {
                setDisabledStatus(false)

            }).catch(() => {
                const detailErrNum = detailAddRef?.current?.detailsForm?.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
                const capacityErrNum = capacityAddRef?.current?.capacityForm?.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
                const serviceErrNum = serviceAddRef?.current?.serviceForm?.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;
                const errTotalNum = detailErrNum + capacityErrNum + serviceErrNum;

                if (errTotalNum === 0) {
                    setDisabledStatus(false)
                } else {
                    setDisabledStatus(true)
                }

            })
    }
    return (
        <div>
            {currentOneNav == 'orign' ? (!mRoomsLoading ? <Tabs defaultActiveKey="1" onChange={origntabsChange} activeKey={orignactiveKey}>
                <TabPane tab="Meeting Rooms" key="1" disabled={OneNavDisabled} forceRender={true}>
                    {allAPIdata && <MeetingRooms meetingroomTabsActivityKey={meetingroomTabsActivityKey} allAPIdata={allAPIdata} OneNavDisabled={OneNavDisabled} setCurrentLine={setCurrentLine} setCurrentOneNav={setCurrentOneNav} setOneNavDisabled={setOneNavDisabled} />}
                </TabPane>
                <TabPane tab="Extra Facility" key="2" disabled={OneNavDisabled}>
                    <ExtraFacilities allAPIdata={allAPIdata} setOneNavDisabled={setOneNavDisabled} />
                </TabPane>
                <TabPane tab="Meeting Payment" key="3" disabled={OneNavDisabled}>
                    <MeetingPayment allAPIdata={allAPIdata} setOneNavDisabled={setOneNavDisabled} />
                </TabPane>
                <TabPane tab="Meeting Rates" key="4" disabled={OneNavDisabled}>
                    <MeetingRates allAPIdata={allAPIdata} setOneNavDisabled={setOneNavDisabled} />
                </TabPane>
            </Tabs> : <Loading type={'large'} />) :

                (currentOneNav == 'view' ? <Tabs defaultActiveKey="8" onChange={tabsEditViewChange} activeKey={editViewActivityKey}>
                    <TabPane tab="Detail" key="8" disabled={tableOneNavDisabled}>
                        {roomDetailEditFlag ? <RoomDetailEdit setOrignactiveKey={setOrignactiveKey} getAllData={getAllData} setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey} setCurrentOneNav={setCurrentOneNav} meetingroomsId={meetingroomsId} setCurrentLine={setCurrentLine} setTableOneNavDisabled={setTableOneNavDisabled} setRoomDetailEditFlag={setRoomDetailEditFlag} currentLine={currentLine} /> :
                            <RoomDetailView setTableOneNavDisabled={setTableOneNavDisabled} setRoomDetailEditFlag={setRoomDetailEditFlag} currentLine={currentLine} setCurrentOneNav={setCurrentOneNav} setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey} />}
                    </TabPane>
                    <TabPane tab="Capacity" key="9" disabled={tableOneNavDisabled}>
                            <RoomCapacity 
                                setTableOneNavDisabled={setTableOneNavDisabled} 
                                setRoomCapacityEditFlag={setRoomCapacityEditFlag} 
                                currentLine={currentLine} 
                                setCurrentOneNav={setCurrentOneNav} 
                                setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey}
                                meetingroomsid={allAPIdata?.meetingrooms?.meetingroomsid}
                                setCurrentLine={setCurrentLine}  
                            />
                    </TabPane>
                    <TabPane tab="Service" key="10" disabled={tableOneNavDisabled}>
                            <RoomService 
                                setTableOneNavDisabled={setTableOneNavDisabled} 
                                setRoomCapacityEditFlag={setRoomCapacityEditFlag} 
                                currentLine={currentLine} 
                                setCurrentOneNav={setCurrentOneNav} 
                                setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey}
                                meetingroomsid={allAPIdata?.meetingrooms?.meetingroomsid}
                                setCurrentLine={setCurrentLine}  
                            />
                    </TabPane>
                </Tabs> 
                : (
                    currentOneNav === 'add' ? (!mRoomsLoading ? <Tabs defaultActiveKey="5" onChange={tabsAddChange} activeKey={addActivityKey}>
                        <TabPane tab="Detail" key="5" forceRender={true}>
                            <RoomDetailAdd validateFieldsError={validateFieldsError} disabledStatus={disabledStatus} setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey} setCurrentOneNav={setCurrentOneNav} ref={detailAddRef} addSave={addSave} />
                        </TabPane>
                        <TabPane tab="Capacity" key="6" forceRender={true} disabled>
                            <RoomCapacity 
                                setTableOneNavDisabled={setTableOneNavDisabled} 
                                setRoomCapacityEditFlag={setRoomCapacityEditFlag} 
                                currentLine={{ capacity: [] }}  
                                setCurrentOneNav={setCurrentOneNav} 
                                setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey}
                                meetingroomsid={allAPIdata?.meetingrooms?.meetingroomsid}
                                setCurrentLine={setCurrentLine}  
                            />
                        </TabPane>
                        <TabPane tab="Service" key="7" forceRender={true} disabled>
                            <RoomService 
                                setTableOneNavDisabled={setTableOneNavDisabled} 
                                setRoomCapacityEditFlag={setRoomCapacityEditFlag} 
                                currentLine={{ service: [] }} 
                                setCurrentOneNav={setCurrentOneNav} 
                                setMeetingroomTabsActivityKey={setMeetingroomTabsActivityKey}
                                meetingroomsid={allAPIdata?.meetingrooms?.meetingroomsid}
                                setCurrentLine={setCurrentLine}  
                            />
                        </TabPane>
                        
                    </Tabs> : <Loading type={'large'} />) : ''
                ))}
        </div>
    )
}

export default MeetingFacilities
